import { uplayConstants } from '../constants'
import { uplayService } from '../../services'

const initialState = {
  authenticated: false,
}

const uplayReducer = (state = initialState, action) => {
  const { response, error } = action
  switch (action.type) {
    // Authenticate
    case uplayConstants.UPLAY_AUTHENTICATE_SUCCESS:
      uplayService.saveUserTicket(response.ticket)
      return { ...state, authenticated: true }
    case uplayConstants.UPLAY_AUTHENTICATE_FAILURE:
      uplayService.removeUserTicket()
      return { ...state, authenticated: false }

    // Logout
    case uplayConstants.UPLAY_LOGOUT_SUCCESS:
      uplayService.removeUserTicket()
      return { ...state, authenticated: false }

    case uplayConstants.UPLAY_ACTIVATE_GAME_SUCCESS:
      return { ...state } // TODO: REMOVE THIS...
    case uplayConstants.UPLAY_ACTIVATE_GAME_FAILURE:
      if (error.errors.errorType === 'UbisoftAuthenticationError') {
        uplayService.removeUserTicket()
        return { ...state, authenticated: false }
      }
      return { ...state }

    case uplayConstants.UPLAY_CHECK_AUTHENTICATE_SUCCESS:
      return { ...state, authenticated: true }
    case uplayConstants.UPLAY_CHECK_AUTHENTICATE_FAILURE:
      return { ...state, authenticated: false }
    default:
      return state
  }
}

export default uplayReducer
